module.exports = __webpack_public_path__ + "img/制御工学2_10.5fecc6c8.png";